import { render, staticRenderFns } from "./ImpersonationView.vue?vue&type=template&id=4ba69266&scoped=true"
import script from "./ImpersonationView.vue?vue&type=script&lang=js"
export * from "./ImpersonationView.vue?vue&type=script&lang=js"
import style0 from "./ImpersonationView.vue?vue&type=style&index=0&id=4ba69266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba69266",
  null
  
)

export default component.exports